import DataTable, { IColumn } from './DataTable'

export type { IColumn }
export default DataTable
